import * as variableApi from "@/api/variable";

const state = () => ({
  variableList: [],
  total: 0,
});

const mutations = {
  SET_VARIABLE_LIST(state, { list, total }) {
    state.variableList = list;
    state.total = total;
  },
};

const actions = {
  // 获取变量列表
  getVariableList({ commit }, params) {
    return new Promise((resolve, reject) => {
      variableApi
        .getVariableList(params)
        .then((res) => {
          if (res.code === "OK") {
            commit("SET_VARIABLE_LIST", {
              list: res.data.list || [],
              total: res.data.total || 0,
            });
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 添加变量
  addVariable({ commit }, data) {
    return new Promise((resolve, reject) => {
      variableApi
        .addVariable(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 更新变量
  updateVariable({ commit }, data) {
    return new Promise((resolve, reject) => {
      variableApi
        .updateVariable(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 删除变量
  deleteVariable({ commit }, params) {
    return new Promise((resolve, reject) => {
      variableApi
        .deleteVariable(params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
